/**
 * 安全设置
 * @returns
 */
import {
  Box,
  Flex,
  Text,
  Image,
  Center,
  Button,
  Input,
  HStack,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useState } from "react";

type AccessData = {
  createAt: string;
  state: string;
  ip: string;
  id: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  dataList: AccessData[];
};

const AccessHistoryModal = (props: Props) => {
  const { isOpen, onClose, dataList } = props;

  return (
    <Modal size={"6xl"} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="743px" bg="#575757">
        <ModalHeader color="#FFFFFF" fontSize={"18px"}>
          访问历史
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <TableContainer>
            <Table variant="unstyled" fontSize="14px" fontWeight={"normal"}>
              <Thead>
                <Tr>
                  <Th
                    color="#CBD1DF"
                    fontSize="14px"
                    fontWeight={"normal"}
                    textAlign="left"
                  >
                    时间戳
                  </Th>
                  <Th
                    color="#CBD1DF"
                    fontSize="14px"
                    fontWeight={"normal"}
                    textAlign="left"
                  >
                    操作
                  </Th>
                  <Th
                    color="#CBD1DF"
                    fontSize="14px"
                    fontWeight={"normal"}
                    textAlign="left"
                  >
                    IP地址
                  </Th>
                  <Th
                    color="#CBD1DF"
                    fontSize="14px"
                    fontWeight={"normal"}
                    textAlign="left"
                  >
                    回话ID
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {dataList.map((row, index) => {
                  return (
                    <Tr key={index} color="#CBD1DF">
                      <Td textAlign="left">{row.createAt}</Td>
                      <Td textAlign="left">{row.state}</Td>
                      <Td textAlign="left">{row.ip}</Td>
                      <Td textAlign="left">{row.id}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AccessHistoryModal;
